import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

export function ReviewRequestText({info}: {info: IssueEventInfo}) {
  const {eventType, reviewerLogin, reviewerTeamSlug} = info
  const reviewer = reviewerLogin ?? reviewerTeamSlug
  if (!reviewer) return <>{eventType === 'review_requested' ? 'requested a review' : 'removed the review request'}</>
  return eventType === 'review_requested' ? (
    <>
      requested a review from <strong>{reviewer}</strong>
    </>
  ) : (
    <>
      removed the review request for <strong>{reviewer}</strong>
    </>
  )
}
